import { render, staticRenderFns } from "./CADetails.vue?vue&type=template&id=1a3bb467&scoped=true&"
import script from "./CADetails.vue?vue&type=script&lang=js&"
export * from "./CADetails.vue?vue&type=script&lang=js&"
import style0 from "./CADetails.vue?vue&type=style&index=0&id=1a3bb467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bb467",
  null
  
)

export default component.exports